import React from 'react';
import { Checkbox } from 'react-toolbox/lib/checkbox';
import syncingInput from 'components/syncingInput';
import styles from 'components/CheckboxSync.css';

const SyncingCheckbox = syncingInput(Checkbox);

const CheckboxSync = ({ progressBarTheme, ...props }) =>
  <SyncingCheckbox progressBarTheme={progressBarTheme || styles} {...props} />;

export default CheckboxSync;
